import { Pipe, PipeTransform } from '@angular/core';
import { FormControl } from '@angular/forms';

function checkControlValid<FormSchema>(control: FormControl<FormSchema>): boolean {
  return control.valid || !(control.touched && control.dirty);
}

@Pipe({
  name: 'formControlValid',
  standalone: true,
})
export class FormControlValidPipe implements PipeTransform {
  public transform(value: unknown, control: FormControl): boolean {
    return checkControlValid(control);
  }
}
